import productIdentity from "./product-identity.json" with { type: "json" };
export const browserTabTitleSeparator = productIdentity.browserTabTitleSeparator;
export function productDocumentTitle(pageName, applicationName) {
    const normalizedPageName = pageName?.trim();
    const normalizedApplicationName = applicationName.trim();
    if (!normalizedPageName || normalizedPageName === normalizedApplicationName)
        return normalizedApplicationName;
    return `${normalizedPageName}${browserTabTitleSeparator}${normalizedApplicationName}`;
}
//# sourceMappingURL=browser-tab-identity.js.map